import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get full file URL from file object or string
 * @param file - File object with fileUrl property or string URL
 * @returns Full URL with base URL prefix
 */
export function getFileUrl(
  file: { fileUrl?: string } | string | undefined
): string | null {
  const fileUrl = typeof file === "string" ? file : file?.fileUrl;
  if (!fileUrl) return null;

  // 🆕 Eğer URL zaten full URL ise (http:// veya https:// ile başlıyorsa), direkt döndür
  if (fileUrl.startsWith("http://") || fileUrl.startsWith("https://")) {
    return fileUrl;
  }

  // Relative path ise baseUrl ekle
  const baseUrl = import.meta.env["VITE_R2_PUBLIC_BASE_URL"];
  return `${baseUrl}/${fileUrl}`;
}

/**
 * Get thumbnail URL from LLM model
 * Prioritizes R2 thumbnail object over thumbnail_url
 * @param model - LLM model with thumbnail or thumbnail_url
 * @returns Full thumbnail URL or null
 */
export function getModelThumbnailUrl(model: {
  thumbnail?: {
    type?: string;
    size?: number;
    folder?: string;
    fileUrl?: string;
  };
  thumbnail_url?: string;
}): string | null {
  // Önce thumbnail objesi varsa R2'den al
  if (model.thumbnail?.fileUrl) {
    return getFileUrl(model.thumbnail);
  }
  // Yoksa thumbnail_url kullan
  return model.thumbnail_url || null;
}
